<div class="min-h-screen bg-gradient-to-br w-full from-slate-50 via-blue-50 to-indigo-100 medical-pattern">
    <!-- Header -->
    <header class="relative  flex w-full justify-center items-center z-10 px-6 py-4">
        <div class="flex items-center justify-center space-x-3 animate-fade-in">
            <div
                class="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-300 rounded-xl flex items-center justify-center shadow-lg">
                <img src="../assets/logo.png" alt="">
            </div>
            <div class="text-2xl font-bold text-gray-800">
                Med<span class="text-blue-500">Fest</span>
            </div>
        </div>
    </header>

    <!-- Main Content -->
    <main class="flex-1 px-6 py-12">
        <div class="max-w-7xl mx-auto">
            <!-- Hero Section -->
            <div class="text-center mb-16 animate-slide-up">
                <h1 class="text-5xl md:text-6xl font-bold text-gray-800 mb-6">
                    EMR PORTAL
                    
                </h1>
                <p class="text-xl text-gray-600 max-w-3xl mx-auto mb-8 leading-relaxed">
                    Connect patients, doctors, and hospitals in one comprehensive platform.
                    Experience seamless healthcare management with cutting-edge technology.
                </p>
                <div class="flex items-center justify-center space-x-4 text-sm text-gray-500">
                    <div class="flex items-center space-x-2">
                        <div class="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                        <span>Secure & HIPAA Compliant</span>
                    </div>
                    <div class="hidden md:block w-1 h-1 bg-gray-300 rounded-full"></div>
                    <div class="flex items-center space-x-2">
                        <div class="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                        <span>24/7 Support</span>
                    </div>
                </div>
            </div>

            <!-- Login Cards -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                <!-- Patients Card -->
                <div class="card-hover cursor-pointer group">
                    <div
                        class="glass-effect rounded-3xl p-8 h-full flex flex-col items-center text-center border shadow-xl">
                        <div
                            class="w-20 h-20 bg-gradient-to-br from-emerald-400 to-cyan-500 rounded-2xl mb-6 flex items-center justify-center shadow-lg group-hover:shadow-2xl transition-all duration-300 animate-float">
                            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </div>
                        <h3 class="text-2xl font-bold text-gray-800 mb-3">Patients</h3>
                        <p class="text-gray-600 mb-6 flex-1">
                            Access your medical records, book appointments, and connect with healthcare providers
                            seamlessly.
                        </p>
                        <div class="w-full">
                            <button routerLink="/login"
                                class="w-full bg-gradient-to-r from-emerald-500 to-cyan-500 text-white font-semibold py-3 px-6 rounded-xl hover:from-emerald-600 hover:to-cyan-600 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl">
                                Patient Login
                            </button>
                        </div>
                        <div class="mt-4 flex items-center space-x-4 text-sm text-gray-500">
                            <div class="flex items-center space-x-1">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                        clip-rule="evenodd" />
                                </svg>
                                <span>Secure</span>
                            </div>
                            <div class="flex items-center space-x-1">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span>Verified</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Doctors Card -->
                <div class="card-hover cursor-pointer group">
                    <div
                        class="glass-effect rounded-3xl p-8 h-full flex flex-col items-center text-center border shadow-xl">
                        <div class="w-20 h-20 bg-gradient-to-br from-rose-400 to-pink-500 rounded-2xl mb-6 flex items-center justify-center shadow-lg group-hover:shadow-2xl transition-all duration-300 animate-float"
                            style="animation-delay: -2s;">
                            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                        </div>
                        <h3 class="text-2xl font-bold text-gray-800 mb-3">Doctors</h3>
                        <p class="text-gray-600 mb-6 flex-1">
                            Manage patient records, schedule appointments, and provide quality healthcare with advanced
                            tools.
                        </p>
                        <div class="w-full">
                            <button routerLink="/login"
                                class="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white font-semibold py-3 px-6 rounded-xl hover:from-rose-600 hover:to-pink-600 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl">
                                Doctor Login
                            </button>
                        </div>
                        <div class="mt-4 flex items-center space-x-4 text-sm text-gray-500">
                            <div class="flex items-center space-x-1">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span>Licensed</span>
                            </div>
                            <div class="flex items-center space-x-1">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                                        clip-rule="evenodd" />
                                </svg>
                                <span>Professional</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Hospital Card -->
                <div class="card-hover cursor-pointer group">
                    <div
                        class="glass-effect rounded-3xl p-8 h-full flex flex-col items-center text-center border shadow-xl">
                        <div class="w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl mb-6 flex items-center justify-center shadow-lg group-hover:shadow-2xl transition-all duration-300 animate-float"
                            style="animation-delay: -4s;">
                            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                        </div>
                        <h3 class="text-2xl font-bold text-gray-800 mb-3">Hospital</h3>
                        <p class="text-gray-600 mb-6 flex-1">
                            Comprehensive hospital management system for streamlined operations and enhanced patient
                            care.
                        </p>
                        <div class="w-full">
                            <button routerLink="/login"
                                class="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold py-3 px-6 rounded-xl hover:from-amber-600 hover:to-orange-600 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl">
                                Hospital Login
                            </button>
                        </div>
                        <div class="mt-4 flex items-center space-x-4 text-sm text-gray-500">
                            <div class="flex items-center space-x-1">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                                        clip-rule="evenodd" />
                                    <path
                                        d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
                                </svg>
                                <span>Enterprise</span>
                            </div>
                            <div class="flex items-center space-x-1">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                        clip-rule="evenodd" />
                                </svg>
                                <span>Scalable</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Features Section -->
            <div class="mt-20 text-center">
                <h2 class="text-3xl font-bold text-gray-800 mb-8">Why Choose MedFest?</h2>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                    <div class="flex flex-col items-center">
                        <div
                            class="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl mb-4 flex items-center justify-center shadow-lg">
                            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                        </div>
                        <h3 class="text-xl font-semibold text-gray-800 mb-2">Lightning Fast</h3>
                        <p class="text-gray-600">Optimized for speed and performance</p>
                    </div>
                    <div class="flex flex-col items-center">
                        <div
                            class="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl mb-4 flex items-center justify-center shadow-lg">
                            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                            </svg>
                        </div>
                        <h3 class="text-xl font-semibold text-gray-800 mb-2">Secure & Private</h3>
                        <p class="text-gray-600">Bank-level security for your data</p>
                    </div>
                    <div class="flex flex-col items-center">
                        <div
                            class="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl mb-4 flex items-center justify-center shadow-lg">
                            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                        </div>
                        <h3 class="text-xl font-semibold text-gray-800 mb-2">Care Focused</h3>
                        <p class="text-gray-600">Designed with patients in mind</p>
                    </div>
                </div>
            </div>
        </div>
    </main>

    <!-- Footer -->
    <footer class="py-8 text-center text-gray-500 text-sm">
        <div class="max-w-7xl mx-auto px-6">
            <p>&copy; 2025 MedFest. All rights reserved. | Transforming Healthcare, One Click at a Time.</p>
        </div>
    </footer>

    <script>
        // Add click handlers for the login cards
        document.addEventListener('DOMContentLoaded', function () {
            const cards = document.querySelectorAll('.card-hover');

            cards.forEach(card => {
                card.addEventListener('click', function () {
                    // Add a subtle click animation
                    this.style.transform = 'scale(0.98)';
                    setTimeout(() => {
                        this.style.transform = '';
                        // Here you would typically redirect to the login page
                        // window.location.href = '/login';
                        console.log('Redirecting to login...');
                    }, 150);
                });
            });
        });
    </script>
</div>
